// import axios from 'axios';
// import {store} from '../Redux/Store.js';

// const API = axios.create({
//   baseURL: process.env.REACT_APP_CARD_URL, // Set your API base URL here
//   headers: {
//     'Content-Type': 'application/json',
//     'x-api-key': 'secret_api_key_123456',
//   },
// });

// export default API;
import axios from 'axios';
const API = axios.create({
  // baseURL: process.env.REACT_APP_CARD_URL, // Set your API base URL here
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': 'secret_api_key_123456',
  },
});

// Helper to set Authorization dynamically
export const setAuthHeader = (token) => {
  if (token) {
    API.defaults.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete API.defaults.headers['Authorization'];
  }
};

export default API;
